import { computed, defineComponent, onMounted } from 'vue';
import SVG from '@dts/shared/src/assets/svg';

import Typography from '@/components/TextFormat/FormatElements/Typography';
import styles from './index.module.scss';

const Notifiy = defineComponent({
  props: {
    notification: {
      type: Object,
      require: true,
      default: () => {},
    },
  },

  setup: (props, context) => {
    const Icon = computed(() => {
      const iconMap = {
        1: <SVG.UserCenterIconTypeUpdate />,
        2: <SVG.UserCenterIconTypePopular />,
        3: <SVG.UserCenterIconTypeGrowth />,
      };
      return iconMap[props.notification?.type] || null;
    });

    return () => (
      <>
        <div class={styles.topTitle}>
          <div class={styles.left}>
            {Icon.value}
            <div class={styles.text}>
              <Typography.Text size={18} weight={700}>
                {props.notification?.type === 1
                  ? 'DTS Update'
                  : props.notification?.type === 2
                  ? 'Popular Topic'
                  : 'Personal Growth'}
              </Typography.Text>
            </div>
          </div>
        </div>
      </>
    );
  },
});
export default Notifiy;
